import React from 'react';
import { Button, Container, Nav, Navbar, Row } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons';
import './Header.css';

const Header = () => {
    const activeMenu = {
        fontWeight: "bold",
        color: "tomato",
    };
    const facebookIcon = <FontAwesomeIcon icon={faFacebook}/>
    const linkedinIcon = <FontAwesomeIcon icon={faLinkedin}/>
    const githubIcon = <FontAwesomeIcon icon={faGithub}/>
    return (
        <>
        <section className="main">
            <div>
                <Container fluid>
                    <Row>
                        <div className="col-md-12">
                        <Navbar bg="dark" expand="lg" sticky="top" className="header-navbar w-100" variant="dark">
                            <Container>
                                <Navbar.Brand>
                                    <Nav.Link as={NavLink} to="/">
                                    <img
                                        src="https://github.com/RomanSheikh99/Images/blob/main/myPic/myPic%20(5).png?raw=true"
                                        width="60"
                                        height="60"
                                        className="d-inline-block align-top navbar-logo"
                                        alt="logo"
                                    />
                                    </Nav.Link>
                                </Navbar.Brand>
                                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                                <Navbar.Collapse id="basic-navbar-nav">
                                    <Nav className="">
                                        <Nav.Link as={NavLink} to="/home" activeStyle={
                                            activeMenu
                                        } className="fs-6 fw-bold px-3">Home</Nav.Link>

                                        <Nav.Link as={NavLink} to="/about" activeStyle={
                                            activeMenu
                                        } className="fs-6 fw-bold px-3">About</Nav.Link>

                                        <Nav.Link as={NavLink} to="/services" activeStyle={
                                            activeMenu
                                        } className="fs-6 fw-bold px-3">Services</Nav.Link>

                                        <Nav.Link as={NavLink} to="/portfolio" activeStyle={
                                            activeMenu
                                        } className="fs-6 fw-bold px-3">Projects</Nav.Link>
                                        <Nav.Link as={NavLink} to="/blog" activeStyle={
                                            activeMenu
                                        } className="fs-6 fw-bold px-3">Blogs</Nav.Link>
                                        
                                        <Nav.Link as={NavLink} to="/contact" activeStyle={
                                            activeMenu
                                        } className="fs-6 fw-bold px-3">Contact</Nav.Link>
                                        
                                    </Nav>
                                    <Nav className="ms-auto align-items-center mobile">
                                        <Nav.Link href="https://www.facebook.com/romansheikh2003/" className="navbar-icons">{facebookIcon}</Nav.Link>
                                        <Nav.Link href="https://www.linkedin.com/in/dev-roman/" className="navbar-icons">{linkedinIcon}</Nav.Link>
                                        <Nav.Link href="https://github.com/RomanSheikh99" className="navbar-icons">{githubIcon}</Nav.Link>
                                    </Nav>
                                    <Nav className="align-items-center">
                                    <Nav.Link as={NavLink} to="/contact" activeStyle={
                                                    activeMenu
                                                } className="fs-6 fw-bold px-3">
                                                    <Button style={{backgroundImage: 'linear-gradient(90deg,#f61b10,#ef0963)', border: 'none'}} className="text-btn fs-6 fw-bold">
                                                        Hire Me
                                                    </Button>
                                                </Nav.Link>
                                    </Nav>
                                </Navbar.Collapse>
                            </Container>
                        </Navbar>
                        </div>
                    </Row>
                </Container>
            </div>
        
        </section>
        </>
    );
};

export default Header;